import { render, staticRenderFns } from "./comp_NewsletterForm.vue?vue&type=template&id=053c91b0&scoped=true&"
import script from "./comp_NewsletterForm.vue?vue&type=script&lang=js&"
export * from "./comp_NewsletterForm.vue?vue&type=script&lang=js&"
import style0 from "./comp_NewsletterForm.vue?vue&type=style&index=0&id=053c91b0&prod&lang=scss&"
import style1 from "./comp_NewsletterForm.vue?vue&type=style&index=1&id=053c91b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c91b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
